import {
  parseZonesFromFieldValues,
  ZONE_FIELD_IDS,
  zoneAnalysisConfigSchema,
  zoneBoxesToDocumentRegions,
} from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'
import { useTicketAccess } from 'features/libra/ticket/TicketAccessContext'
import { useWorkflow } from 'features/libra/WorkflowContext'
import { Component as DocumentViewerPanel } from 'features/libra/workspacePanels/DocumentViewerPanel'
import { FC, useMemo } from 'react'

export const Component: FC = () => {
  const workflow = useWorkflow()
  const { fieldValues } = useTicketAccess()
  const zoneAnalysisStep = workflow.steps.find(
    (step) => step.component === 'ZoneAnalysis'
  )
  const isNormalNii = Boolean(
    zoneAnalysisStep &&
    !workflow.steps.some((step) => step.component === 'NiiInspectionAreas')
  )
  const zoneFieldName = zoneAnalysisStep
    ? (zoneAnalysisConfigSchema.safeParse(zoneAnalysisStep.config).data
        ?.zoneFieldName ?? ZONE_FIELD_IDS.ZONES)
    : ZONE_FIELD_IDS.ZONES
  const liveZones = useMemo(
    () =>
      isNormalNii
        ? zoneBoxesToDocumentRegions(
            parseZonesFromFieldValues(fieldValues, zoneFieldName).zones
          )
        : [],
    [fieldValues, isNormalNii, zoneFieldName]
  )

  return <DocumentViewerPanel liveZones={liveZones} />
}
